/* =======================================================================
   HomePage — Sezioni mostrate sulla home page (in ordine, dall'alto in basso)
   =======================================================================
   Per cambiare l'ordine delle sezioni: sposta le righe qui sotto.
   Per nascondere una sezione: cancella (o commenta) la sua riga.
   Per aggiungere una sezione esistente: importala in alto e aggiungi il tag.
   ======================================================================= */
import copy from "@/data/copy";
import Hero from "@/components/site/Hero";              // Video di sfondo + bottoni
import Intro from "@/components/site/Intro";            // Sezione "Benvenuti" con firma
import Poem from "@/components/site/Poem";              // Poesia "Viva la Pizza" (sfondo rosso)
import Philosophy from "@/components/site/Philosophy";  // 4 card colorate
import Doughs from "@/components/site/Doughs";          // Blocco "Impasti speciali"

export default function HomePage() {
  return (
    <div data-testid="page-home">
      <Hero copy={copy} />
      <Intro copy={copy} />
      <Poem copy={copy} />
      <Philosophy copy={copy} />
      <Doughs copy={copy} />
    </div>
  );
}
